<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar OS Saída",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Loader, PageHeader, Multiselect,Layout },
  data() {
    return {
      title: "Editar OS de Saída",
      items: [
        {
          text: "Ordens de Serviço",
          href: "/wmsossaida/list",
        },
        {
          text: "Editar OS de Saída",
          active: true
        }
      ],
      itenswmsos: {},
      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsListData: null,
      wmsOsData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },
      wmsOsDuplicadaData: null,
      desativaFuncoes: false,
      clienteData: {},
      movData: {},
      wmsOsPedsData: {},
      wmsOsPedsES: {},
      wmsOsItemData: {},
      wmsOsItensData: {},
      wmsOsItensSepData: {},
      wmsOsItensSepPendData: [],
      wmsOsVolumesData: {},
      wmsOsVolumeData: {
        caixa: 1
      },
      optionsCaixas: {},

      selectedItem: null,
      submitted: false,
      errosValid: null,
      tipoConferencia: 'A',
      tipoVolume: 'A',
      showModalVolume: false,
      loadingWmsVolume: false,
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      showAssocRoma: false,
      showConfManual:false,
      showModalLote:false,
      showListConf:false,
      showListPed: false,
      showListFerramentas:false,
      dtListPesqRoma: null,
      disabledChave: false,
      flagAvulso: true,
      flagdispconf: null,
      autoImpressao: true,
      empresaData: {},
      tamanhoTela: 0,
      mudarConferencia: 'P',

      flagConferenciaCompos: false,
      wmsositemLotes: [],
      dtListLotes: [],
      itemResetLote: {
        endwms: "-",
        lote: "-",
      },
      flagProdutoSaldoWmsos: false,
      activeStep: 1,
      totalItens: 0
    }
  },
  created() {
  },
  mounted() {
    console.log('mounted_wmsOs_editar_transp_0')
    this.tamanhoTela = window.innerWidth
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.produto.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })

    whenever(keys.alt_a, () => {
      this.efetivarSepPend2()
    })

    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0) {
      this.carregarDados()

    } else {

      this.title = `Criando Nova OS`
      this.updating = false
      this.flagAvulso = true
      this.autoImpressao = true

      this.carregaWmsOsAvulso()

    }
  },

  computed: {
    computedDisabledChave(){
      if(this.idData === 0){
        return false
      }else{
        return true
      }
    },

    filteredItens() {
      // Filtra itens com base no código do produto inserido
      return this.wmsOsItensData.filter(item =>
          item.produto === this.wmsOsItemData.produto
      );
    }
  },

  methods: {

    goToStep(step){
      console.log('goToStep')
      this.activeStep = step;
    },

    gerarReservaSaldos(){
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote
        }).then((res) => {
          console.log("then axios reservasaldolotes");
          console.log(res.data)
          console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    criaMovAjtFromWms() {
      console.log('criaMovAjtFromWms')

      if(this.tamanhoTela > 500) {
        api.post(`${getBaseUrl()}api/criamovajtmovs`, {
          produtosErros: this.dtListErrorsProdutos,
          remetcnpj: this.remetCnpj,
          tabela: 'mov',
          origens_id: this.listaIds
        }).then((res) => {
          console.log('then axios criamovajtmovs')
          console.log(JSON.stringify(res.data))

          if (res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              text: res.data.message ?? "Ajuste criado com sucesso!",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              const movajt_id = res.data.movajt_id
              if (movajt_id > 0) {
                let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
                window.open(route.href, '_blank');
                this.showModalErrosProdutos = false
              } else {
                let route = this.$router.resolve(`/movajustes/list`);
                window.open(route.href, '_blank');
              }

            });
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              text: res.data.error ?? "Criação de Ajuste Falhou!",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              this.carregarDados()
            });
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "Warning",
          text: "Necessário Criação de Ajuste! Contate o Administrativo!",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          this.carregaWmsOsAvulso()
        });
      }
    },

    selecionouLote(evt) {
      console.log('selecionouLote')
      // console.log(evt)

      if (evt !== null ) {
        let selecionados = Array.isArray(evt) ? evt : [evt]

        let lotesSelecionados = this.dtListLotes.filter(lote => selecionados.includes(lote.lote))

        console.log('lotesSelecionados')
        console.log(lotesSelecionados)

        const item = this.wmsOsItensData.find(i => i.produto_id === this.wmsOsItemData.produto_id)

        if (!item) {
          console.error('item não encontrado!')
        }

        item.endwms = lotesSelecionados.map(lote => lote.endwms)
        item.lote = lotesSelecionados.map(lote => lote.lote)
      }

      this.informouProduto()
      this.$refs.qtdlida.focus()
    },

    opcoesLotes(){
      // console.log('---------opcoesLotes---------')
      // console.log('wmsOsItemData: ' , this.wmsOsItemData["produto_id"])

      api.get(`${getBaseUrl()}api/pesqlotes`, {
        params: {
          produto_id: this.wmsOsItemData["produto_id"],
          qtd: this.wmsOsItemData["qtddisp"],
        },
      }).then((res) => {
        console.log("then axios pesqlotes");
        console.log(res.data);

        this.dtListLotes = res.data

        this.showModalLote = true
      })
    },

    redirecionaOrigem(){
      console.log('redirecionaOrigem')
      let url = ''
      switch(this.wmsOsData.origem) {
        case 'orcamento':
            url = `/orcamento/editar/${this.wmsOsData.origem_id}`
            window.open(url, '_blank')
              break
        case 'mov':
          url = `/movimento/editar/${this.wmsOsData.origem_id}`
          window.open(url, '_blank')
              break
        case 'movcompra':
          url = `/movcompra/editar/${this.wmsOsData.origem_id}`
          window.open(url, '_blank')
              break
      }
    },

    finalizarParcial(){
      console.log('finalizarParcial')
      if (this.empresaData?.editvolfinconf === true) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Deseja editar os Volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'conffinparcial'
          } else {
            this.confFinalizarParcial()
          }
        })

      } else {
        this.confFinalizarParcial()
      }
    },

    confFinalizarParcial(){
      console.log('conffinalizarParcial...')

      Swal.fire({
        position: "center",
        icon: 'info',
        title: 'Confirmar a finalização parcial',
        showCancelButton: true,
        showConfirmButton: true
      }).then((value) => {
        console.log(value)
        if(value.isConfirmed){
          this.selectedFinalizado = true
          this.showModalMsgUpdating = true

          api.post(`${getBaseUrl()}api/wmsosfinalparcial`, {
            'movItemSepPendData': this.wmsOsItensSepPendData,
            'movItemSepData': this.wmsOsItensSepData,
            'idwmsos': this.idData
          }).then((res) => {
            this.selectedFinalizado = false
            this.showModalMsgUpdating = false
            console.log('then axios finalizarParcial')
            console.log(res.data)

            let flag = res.data.success ?? false

            if(flag){
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                title: 'Redirecionando para o pedido gerado!',
                timer: 1500
              }).then(() => {
                // this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
                this.recarregaWmsosAvulso()
              })
            }else{
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              })
            }
            this.showListFerramentas = false
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
        }
      })
    },

    efetivarSepPend(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      api.post(`${getBaseUrl()}api/wmsositconfseptramuito`, {
        'movItemSepPendData': this.wmsOsItensSepPendData,
        'autoImpressao': this.autoImpressao,
        'idwmsos': this.idData
      }).then((res) => {
        console.log('then axios separarPend')
        console.log(res.data)
        this.wmsOsItensSepData = res.data[0]
        this.wmsOsData = res.data[1]

        /*
        * Validando se conferência foi finalizada
        * Se origem for mov, retornar para lista
        */
        if(this.wmsOsData.origem === 'mov'){
          this.$router.replace(`/wmsossaida/list`)
          this.carregaWmsOsAvulso()
        }

        this.wmsOsItensData = this.filtrarDisponiveis(res.data[2])
        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }
        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }
        this.wmsOsVolumesData = res.data[3]
        if (this.wmsOsItensData.length === 0) {
          console.log('finalizar_auto')
          this.wmsOsData.status = 'SE'
          this.confirmarFinalizar()
        } else {
          console.log('produto focus')
          setTimeout(() => {
            this.$refs.produto.focus()
          }, 500);
        }
      }).then(() => {
        this.updatingListas = false
        this.wmsOsItemData.qtd = 0
        this.wmsOsItemData.qtdlida = 0
        this.wmsOsItemData.produto = ''
      })


    },

    efetivarSepPend2(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      api.post(`${getBaseUrl()}api/wmsositconfseptramuito`, {
        'movItemSepPendData': this.wmsOsItensSepPendData,
        'autoImpressao': this.autoImpressao,
        'idwmsos': this.idData
      }).then((res) => {
        console.log('then axios separarPend')
        console.log(res.data)
        console.log(JSON.stringify(res.data))

        if(!res.data.finalizado){
          console.log('conferência salva')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },

    changeAutoImpressao(){
      this.autoImpressao = !this.autoImpressao
      console.log(`auto impressão: ${this.autoImpressao}`)
    },

    recarregaWmsosAvulso(){
      console.log('recarregando conferência avulsa...')

      this.$router.push(`/coletor/conferenciacoletor/0`).then((blankWmsos) => {
        window.open(blankWmsos, '_self')
        this.atualizaPagina()
      })
    },

    retornaParaWmsos(){
      console.log('retornaParaWmsos')
      this.$router.replace('/wmsossaida/list')
    },

    carregaWmsOs(){
      console.log(`nota fiscal / OS: ${this.movData.chave}`)

      if(!this.movData.chave){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Ordem de Serviço inválida!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        api.post(`${getBaseUrl()}api/wmsosindividual`, {
          'chave': this.movData.chave
        }).then((res) => {
          console.log('then axios wmsosindividual')
          console.log(res.data)

          if(!res.data.success){
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          }else{
            this.movData = res.data.wmsos
            this.idData = this.movData.id

            this.$router.push(`/coletor/conferenciacoletor/${this.movData.id}`)
            this.carregarDados()
          }
        }).catch(() => {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de Serviço inválida",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    excluir() {
      console.log('excluir')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Ordem",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/wmsos`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            if(res.data.redirecionaEstoque){
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Saldo bloqueado!",
                text: "Deseja redirecionar-se transferência de saldos?",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
              }).then((check) => {
                if(check.isConfirmed){
                  this.$router.push('/produtos/listestoque')
                }else{
                  this.$router.push('/wmsossaida/list')
                }
              })
            }else{
              if(res.data.success){
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  // this.$router.replace('/wmsossaida/list')
                  this.recarregaWmsosAvulso()
                })
              }else{
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          })
          this.showListFerramentas = false
        }
      })
    },

    onModalClosed() {
      console.log('onModalClosed')
      this.showModalVolume = false

      if(this.flagdispconf !== null) {
        if(this.flagdispconf === 'finConfSepTodos'){
          // console.log('confSepararTodos')
          this.confSepararTodos()
        }else if(this.flagdispconf === 'finConfIndividual') {
          // console.log('disparoFinalizadorConferencia')
          this.disparoFinalizadorConferencia()
        } else if(this.flagdispconf === 'conffinparcial'){
          // console.log('confFinalizarParcial')
          this.confFinalizarParcial()
        }
      }
    },

    separarTodos() {
      console.log('separarTodos')

      if (this.empresaData?.editvolfinconf === true) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Volumes Separar Todos",
          text: "Deseja adicionar ou editar os volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'finConfSepTodos'
          } else {
            this.confSepararTodos()
          }
        })

      } else {
        this.confSepararTodos()
      }

    },

    confSepararTodos(){
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Separar Todos Itens",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          console.log(result.value)
          console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true
          this.selectedFinalizado = true
          this.showModalMsgUpdating = true
          api.post(`${getBaseUrl()}api/wmsosseptodos`, {
            'iddata': this.idData
          }).then((res) => {
            this.selectedFinalizado = false
            this.showModalMsgUpdating = false
            console.log('then axios separar2_1')
            console.log(res.data)

            let flag = res.data.success ?? false

            if (flag) {
              if (res.data?.fluxo === 'orcamento') {
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: 'Redirecionando para o pedido gerado!',
                  timer: 1500
                }).then(() => {
                  // this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
                  this.recarregaWmsosAvulso()
                })
              } else {
                Swal.fire({
                  icon: 'success',
                  position: 'center',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: res.data.message,
                  timer: 2500
                }).then(() => {
                  // this.$router.push(`/wmsossaida/list`)
                  this.recarregaWmsosAvulso()
                })
              }
            } else {
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              })
            }
            this.showListFerramentas = false
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
        }
      })
    },

    finalizadorConferencia() {
      console.log('finalizadorConferencia')
      if (this.empresaData?.editvolfinconf === true) {
        this.updating = true

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Deseja editar os Volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          this.updating = false
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'finConfIndividual'
          } else {
            this.disparoFinalizadorConferencia()
          }
        })

      } else {
        this.disparoFinalizadorConferencia()
      }
    },

    disparoFinalizadorConferencia() {
      console.log('disparoFinalizadorConferencia')

      this.wmsOsItemData['idwmsos'] = this.idData
      this.updatingListas = true
      this.selectedFinalizado = true
      this.showModalMsgUpdating = true
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsosseptodos`, {
        'iddata': this.idData
      }).then((res) => {
        this.updating = false
        this.selectedFinalizado = false
        this.showModalMsgUpdating = false
        console.log('then axios separar2_1')
        console.log(res.data)

        let flag = res.data.success ?? false

        if(flag){
          if (res.data?.fluxo === 'orcamento') {
            Swal.fire({
              icon: 'success',
              position: 'top-end',
              showCancelButton: false,
              showConfirmButton: false,
              title: 'Redirecionando para o pedido gerado!',
              timer: 1500
            }).then(() => {
              this.recarregaWmsosAvulso()
            })
          } else {
            Swal.fire({
              icon: 'success',
              position: 'center',
              showCancelButton: false,
              showConfirmButton: false,
              title: res.data.message,
              timer: 2500
            }).then(() => {
              this.recarregaWmsosAvulso()
            })
          }
        }else{
          Swal.fire({
            icon: 'error',
            position: 'top-end',
            showCancelButton: false,
            showConfirmButton: false,
            text: res.data.message,
            timer: 3000
          })
        }
      }).catch((e) => {
        console.log('error...')
        console.log(e)
      })
    },

    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CF':
          result = 'Conferido'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'EQ':
          result = 'Embarque'
          break
        case 'FN':
          result = 'Finalizado'
          break
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    excluirEtiquetas() {
      console.log('excluirEtiquetas')
      this.showModalVolume = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Todas as Etiquetas",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/wmsosetiquetas`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },

    abrirModalVolume() {
      console.log('abrirModalVolume')
      this.showModalVolume = true
      this.showListFerramentas = false
    },

    associarRomaneio() {
      console.log('associarRomaneio')
      this.showListFerramentas = false
      if (this.wmsOsData.origem2 === 'romaneio') {
        this.$router.push(`/wmsos/saidaromaeditar/${this.idData}`)
      } else {
        this.showAssocRoma = true
      }
    },

    atualizaPagina() {
      window.location.reload();
    },

    confirmarAssocRoma() {
      console.log('associarRomaneio')
      // console.log(this.wmsosList)

      let idsAssoc = []
      idsAssoc.push(this.idData)


      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        idRoma: this.wmsOsData.wmsroma_id,
        idsData: idsAssoc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        //this.atualizaDataList()
      })
    },


    pesqRomaneio(evt) {
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },


    imprimirEtiquetas() {
      console.log('imprimirEtiqueta')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstra`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        // var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        // var fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', 'etiqueta_.pdf');
        // document.body.appendChild(fileLink);
        // fileLink.click();


        this.updating = false
        this.showListFerramentas = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Impressão enviada com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      })
    },


    imprimirEtiquetasZpl() {
      console.log('imprimirEtiqueta')
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsosvoletiqstrazpl`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then imprimirEtiquetas')
        console.log(res.data)
        // var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        // var fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', 'etiqueta_.zpl');
        // document.body.appendChild(fileLink);
        // fileLink.click();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Comando de impressão executado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.updating = false
        this.showListFerramentas = false
      })
    },


    imprimirEtiquetasMiniDanfe() {
      console.log('imprimirEtiquetasMiniDanfe')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstrazpl`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.zpl');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },

    escolheuCaixa(){
      console.log('escolheuCaixa')
      // const caixaId = this.wmsOsVolumeData.caixa;
      // console.log('caixaId', caixaId)
      // const caixaSelecionada = this.optionsCaixas.find(c => c.id === caixaId);
      this.$refs.qtdvolume.focus()
    },

    informouQtdVolume() {
      console.log('informouQtdVolume')
      this.$refs.pesovolume.focus()

    },

    informouPeso() {
      console.log('informouPeso')
      this.confirmarVolume()

    },

    imprimirEtiqueta(idVol) {
      console.log('imprimirEtiqueta')
      this.loadingWmsVolume = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqtra`, {
        responseType: 'blob',
        params: { iddata: idVol }
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingWmsVolume = false
      })

    },


    finalizar() {
      console.log('finalizar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Finalizar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.confirmarFinalizar()
          this.showListFerramentas = false
        }
      })
    },

    confirmarFinalizar(){
      console.log('confirmarFinalizar')
      // console.log('vai')
      // this.wmsOsItemData['idwmsos'] = this.idData
      // this.updatingListas = true
      //
      api.post(`${getBaseUrl()}api/wmsosfinalsep`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios separar2_0')
        console.log(res.data)

        if (res.data.processo === 'pedido') {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comando Finalizar executado com sucesso, abrindo pedido de destino.",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            // this.$router.push(`/pedido/detalhe/${res.data['id']}`)
            this.recarregaWmsosAvulso()
          })
          // console.log('redirect to pedido')
          // this.$router.push(`/pedido/detalhe/${res.data['id']}`)
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comando Finalizar executado com sucesso, abrindo próxima OS em aberto.",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            if(this.flagAvulso){
              this.recarregaWmsosAvulso()
            }else{
              const routeData = this.$router.resolve(`/coletor/conferenciacoletor/${res.data['id']}`)
              window.open(routeData.href, '_blank')
            }
          })
        }
      })
    },


    abrirOutraOS(idos) {
      const routeData = this.$router.resolve(`${idos}`)
      window.open(routeData.href, '_blank')
    },

    reiniciar() {
      console.log('reiniciar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          console.log(result.value)
          console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosreinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2_1')
            console.log(res.data)
            this.wmsOsItensSepData = {}
            this.wmsOsItemData.produto = ''

            this.wmsOsItensData = this.filtrarDisponiveis(res.data[0])

            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }



            this.wmsOsData = res.data[1]
            this.updatingListas = false
            this.showListFerramentas = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })

    },


    clicouProduto(codigo, iditem, produto_id, compos_qtd, compos_fator, lote, endwms) {
      console.log('=============== clicouProduto ===============')
      // console.log(codigo)
      this.showListConf = false

      this.wmsOsItemData.produto = codigo
      this.wmsOsItemData.produto_id = produto_id
      this.wmsOsItemData.iditem = iditem
      this.wmsOsItemData.endwms = endwms ?? null
      this.wmsOsItemData.lote = lote ?? null

      /*
      * Valida se conferência contém item composto
      */
      let qtddisp = 0
      let qtd = 0
      this.wmsOsItensData.forEach((item) => {

        if (item.id === this.wmsOsItemData.iditem) {
          //console.log(`item encontrado clicou produto: ${JSON.stringify(item)}`)

          if(item.desconsidsaldo){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Item com saldo desconsiderado para conferência!",
              text: "Item indisponível",
              showConfirmButton: false,
              timer: 2000
            })

            this.wmsOsItemData = {}
          }

          this.wmsOsItemData.compos_qtd = parseFloat(compos_qtd)
          this.wmsOsItemData.compos_fator = compos_fator
          qtddisp = item.qtddisp
          qtd = item.qtddisp
          this.wmsOsItemData.descprod = item.descprod
        }
      });

      this.wmsOsItemData.qtd = qtd
      this.wmsOsItemData.qtdlida = 0

      this.wmsOsItemData.qtddisp = qtddisp

      //console.log(`wmsOsItemData clicouProduto: ${JSON.stringify(this.wmsOsItemData)}`)

      if (this.flagProdutoSaldoWmsos && (this.wmsOsItensData.deflote === true && !this.wmsOsItensData.lote)) {
        this.$refs.selectLotes.focus()
      } else {
        this.$refs.produto.focus()
      }
    },

    clicouPedido(idPed) {
      console.log('clicouPedido')

      this.showListPed = false
      this.movData.chave = idPed;

      setTimeout(() => {
        this.$refs.chave.focus()
      }, 500)
    },

    informouProduto() {
      console.log('=============== informouProduto ===============')

      if(this.wmsOsData.status === 'SE' && this.wmsOsData.status === 'SE'){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Operação proibida",
          text: "Status de OS com separação finalizada!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        let encontrouProd = false
        if(this.wmsOsItemData === null || (!this.wmsOsItemData.iditem && this.wmsOsItemData.produto)) {
          let qtddisp = 0
          let qtd = 0
          this.wmsOsItensData.forEach((value) => {
            if ((value.id === this.wmsOsItemData.iditem) || (this.wmsOsItemData.produto === value.produto) || (this.wmsOsItemData.produto === value.codbarra)) {
              console.log('primeiro caso')
              this.wmsOsItemData.produto = value.produto
              this.wmsOsItemData.produto_id = value.produto_id
              this.wmsOsItemData.descprod = value.descprod
              this.wmsOsItemData.qtd = value.qtddisp
              this.wmsOsItemData.iditem = value.id
              this.wmsOsItemData.lote = value.lote ?? null

              if (value.id === this.wmsOsItemData.iditem) {

                if(value.desconsidsaldo){
                  Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Item com saldo desconsiderado para conferência!",
                    text: "Item indisponível",
                    showConfirmButton: false,
                    timer: 2000
                  })

                  this.wmsOsItemData = {}
                }
                const composicao = value.composicao

                if(composicao){
                  this.wmsOsItemData.compos_qtd = parseFloat(composicao.qtd)
                  this.wmsOsItemData.compos_fator = composicao.fator
                }

                qtddisp = value.qtddisp
                qtd = value.qtddisp
                this.wmsOsItemData.descprod = value.descprod
              }

              this.wmsOsItemData.qtd = qtd
              this.wmsOsItemData.qtdlida = 0

              this.wmsOsItemData.qtddisp = qtddisp

              this.selectedItem = value;

              if (this.tipoConferencia === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  this.wmsOsItemData.qtdlida = 1

                }

                console.log(`wmsOsItemData informouProduto: ${JSON.stringify(this.wmsOsItemData)}`)
                this.informouQtdLida2()
              } else if(this.tamanhoTela < 500) {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
                this.abrirShowConfManual()

              } else {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
              }
              encontrouProd = true
            }
          });
        } else {
          console.log('segundo caso')

          this.wmsOsItensData.forEach((value) => {
            if(value.id === this.wmsOsItemData.iditem) {

              this.selectedItem = value;

              if (this.tipoConferencia === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  console.log('quantidade produto composto')
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  console.log('quantidade automática')
                  this.wmsOsItemData.qtdlida = 1
                }

                console.log(`wmsOsItemData informouProduto: ${JSON.stringify(this.wmsOsItemData)}`)

                this.informouQtdLida2()
              } else if(this.tamanhoTela < 500) {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
                this.abrirShowConfManual()

              } else {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
              }
              encontrouProd = true
            }
          });
        }
        if (!encontrouProd) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Produto Inválido",
            text: "Código inválido ou já finalizado!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    informouQtdLida() {
      console.log('-- informouQtdLida --')
      //console.log(`qtdlida: ${this.wmsOsItemData.qtdlida}`)
      //console.log(`qtddisp: ${this.wmsOsItemData.qtddisp}`)
      //console.log(`wmsOsItemData: ${JSON.stringify(this.wmsOsItemData)}`)

      let passaSaldo = false
      let qtdLidaAtual = 0

      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        this.showConfManual = false

        if (
            window.location.href.includes('localhost')
            || window.location.href.includes('compose')
            || window.location.href.includes('grupofesta')
            || window.location.href.includes('granlog')
            || window.location.href.includes('vitascience')
            || window.location.href.includes('jsalog')
            || window.location.href.includes('econopro')
            || window.location.href.includes('delio') //Ambiente de testes do Délio
        ) {
          // acumular lista para separar muitos
          //console.log('acumular lista para separar muitos')

          let quantDisponivel = false

          for(const prod of this.wmsOsItensData) {
            if (prod.id === this.wmsOsItemData.iditem) {
              //console.log(`prod atual para baixa: ${JSON.stringify(prod)}`);

              if (!this.wmsOsItemData.lote && (prod.deflote && !prod.lote)) {
                this.opcoesLotes()
                return;
              }

              this.showModalLote = false

              qtdLidaAtual = this.roundToDecimal(parseFloat(this.wmsOsItemData.qtdlida), 4);
              //console.log(`baixa qtdLidaAtual: ${qtdLidaAtual}`);

              if (prod.composicao) {
                if (prod.qtddisp >= 0) {
                  console.log('baixa de produto composição...');

                  prod.qtdlida += qtdLidaAtual;
                  prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                  quantDisponivel = true;
                  //console.log(`qtddisp remaining: ${prod.qtddisp}`);

                  // Validando se terminou de conferir o item atual
                  if (prod.qtddisp < 0) {
                    prod.qtddisp = 0;
                    quantDisponivel = false;
                  }
                }
              } else {
                //console.log('baixa de produto comum...');

                if (prod.qtddisp >= qtdLidaAtual) {
                  prod.qtdlida += qtdLidaAtual;
                  prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                  quantDisponivel = true;
                }
              }

              if (prod.qtddisp === 0) {
                this.wmsOsItensData.splice(this.wmsOsItensData.indexOf(prod), 1);
              }
              break;
            }
          }


          if (quantDisponivel === false) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Quantidade do produto indisponível para separação",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          } else {
            if (this.wmsOsItemData.lote) {
              const lote = this.wmsOsItemData.lote;
              // console.log(`informouQtdLida lote: ${lote}`)

              const endwms = this.wmsOsItemData.endwms
              // console.log(`informouQtdLida endwms: ${endwms}`)

              let existeProdPend = false;
              let existeProd = false;

              /* verificando se lote já existe em wmsOsItensSepPendData */
              this.wmsOsItensSepPendData.forEach((prod) => {
                //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProdPend = true;

                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /* verificando se lote já existe em in wmsOsItensSepData */
              this.wmsOsItensSepData.forEach((prod) => {
                //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProd = true;

                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /* Criando novos itens nas coleções */
              if (!existeProdPend) {
                this.wmsOsItensSepPendData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'lote': lote,
                  'endwms': endwms,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }

              if (!existeProd) {

                this.wmsOsItensSepData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'lote': lote,
                  'endwms': endwms,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }
              //console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
              //console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)

            } else {
              let existeProdPend = false;
              let existeProd = false;

              this.wmsOsItensSepPendData.forEach((prod) => {
                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProdPend = true;
                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              this.wmsOsItensSepData.forEach((prod) => {
                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProd = true;
                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /*Criando novos itens nas coleções */
              if (!existeProdPend) {
                this.wmsOsItensSepPendData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.wmsOsItemData.qtdlida,
                  'qtd': this.wmsOsItemData.qtdlida,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }

              if (!existeProd) {
                this.wmsOsItensSepData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.wmsOsItemData.qtdlida,
                  'qtd': this.wmsOsItemData.qtdlida,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }
              //console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
              //console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)
            }

            //ordenando em desc e destacando o item atual para o topo
            const idItemAtual = this.wmsOsItemData.iditem

            const itemAtual = this.wmsOsItensSepData.find(item =>
                item.iditem === idItemAtual
            );
            const outrosItens = this.wmsOsItensSepData.filter(item =>
                !(item.iditem === idItemAtual)
            );

            if (outrosItens && outrosItens.length > 0) {
              outrosItens.sort((a, b) => b.iditem - a.iditem);

              this.wmsOsItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
            } else if (itemAtual) {
              this.wmsOsItensSepData = [itemAtual]
            }

            if (this.wmsOsItensData.length === 0) {
              this.efetivarSepPend()
            }

            this.wmsOsItemData = {}
            this.$refs.produto.value = null
            this.$refs.qtdlida.value = null

            this.$refs.produto.focus()
          }
        } else {
          console.log('vai')
          console.log(this.wmsOsItemData)
          this.updatingListas = true
          this.wmsOsItemData['idwmsos'] = this.idData
          api.post(`${getBaseUrl()}api/wmsositconfseptransp`, {
            'movItemSepData': this.wmsOsItemData,
            'autoImpressao': this.autoImpressao
          }).then((res) => {
            console.log('then axios separar2_2')
            console.log(res.data)
            this.wmsOsItensSepData = res.data[0]
            this.wmsOsData = res.data[1]
            this.wmsOsItensData = this.filtrarDisponiveis(res.data[2])
            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }
            if (this.wmsOsItensSepData.length > 0) {
              this.wmsOsItensSepData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }
            this.wmsOsVolumesData = res.data[3]
            if (this.wmsOsItensData.length === 0) {
              console.log('finalizar_auto')
              this.wmsOsData.status = 'SE'
              this.confirmarFinalizar()
            } else {
              console.log('produto focus')
              setTimeout(() => {
                this.$refs.produto.focus()
              }, 500);
            }
          }).then(() => {
            this.updatingListas = false
            this.wmsOsItemData.qtd = 0
            this.wmsOsItemData.qtdlida = 0
            this.wmsOsItemData.produto = ''
          })
        }
      }
    },

    /*
    * Por hora será utilizado para os clientes até desenvolvimento de disparo de dados para o back-end para cada bip
    */
    informouQtdLida2() {
      //console.log('=============== informouQtdLida2 ===============')
      //console.log(`qtdlida: ${this.wmsOsItemData.qtdlida}`)
      //console.log(`qtddisp: ${this.wmsOsItemData.qtddisp}`)
      //console.log(`wmsOsItemData: ${JSON.stringify(this.wmsOsItemData)}`)


      let passaSaldo = false
      let qtdLidaAtual = 0

      //!this.wmsOsItemData.qtddisp || this.wmsOsItemData.qtdlida > this.wmsOsItemData.qtddisp
      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        // acumular lista para separar muitos
        //console.log('acumular lista para separar muitos')

        this.showConfManual = false

        let quantDisponivel = false

        for(const prod of this.wmsOsItensData) {
          if (prod.id === this.wmsOsItemData.iditem) {
            //console.log(`prod atual para baixa: ${JSON.stringify(prod)}`);

            if (!this.wmsOsItemData.lote && (prod.deflote && !prod.lote)) {
              this.opcoesLotes()
              return;
            }

            this.showModalLote = false

            qtdLidaAtual = this.roundToDecimal(parseFloat(this.wmsOsItemData.qtdlida), 4);
            //console.log(`baixa qtdLidaAtual: ${qtdLidaAtual}`);

            if (prod.composicao) {
              if (prod.qtddisp >= 0) {
                //console.log('baixa de produto composição...');

                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
                //console.log(`qtddisp remaining: ${prod.qtddisp}`);

                // Validando se terminou de conferir o item atual
                if (prod.qtddisp < 0) {
                  prod.qtddisp = 0;
                  quantDisponivel = false;
                }
              }
            } else {
              //console.log('baixa de produto comum...');

              if (prod.qtddisp >= qtdLidaAtual) {
                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
              }
            }

            if (prod.qtddisp === 0) {
              this.wmsOsItensData.splice(this.wmsOsItensData.indexOf(prod), 1);
              this.totalItens--
            }
            break;
          }
        }


        if (quantDisponivel === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Quantidade do produto indisponível para separação",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          if (this.wmsOsItemData.lote) {
            //console.log("LOTE INFORMADO", this.wmsOsItemData)

            const lote = this.wmsOsItemData.lote;
            //console.log(`informouQtdLida2 lote: ${lote}`)

            const endwms = this.wmsOsItemData.endwms
            //console.log(`informouQtdLida2 endwms: ${endwms}`)

            let existeProdPend = false;
            let existeProd = false;

            /* verificando se lote já existe em wmsOsItensSepPendData */
            this.wmsOsItensSepPendData.forEach((prod) => {
              //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProdPend = true;
                //console.log('atualizando dados do item na lista wmsOsItensSepPendData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  //console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  //console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* verificando se lote já existe em in wmsOsItensSepData */
            this.wmsOsItensSepData.forEach((prod) => {
              //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProd = true;
                //console.log('atualizando dados do item na lista wmsOsItensSepData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  //console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  //console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* Criando novos itens nas coleções */
            if (!existeProdPend) {
              //console.log('criando novo item na lista wmsOsItensSepPendData')

              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              //console.log('criando novo item na lista wmsOsItensSepData')

              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }
            //console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
            //console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)

          } else {
            let existeProdPend = false;
            let existeProd = false;

            this.wmsOsItensSepPendData.forEach((prod) => {
              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProdPend = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });


            this.wmsOsItensSepData.forEach((prod) => {
              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProd = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /*Criando novos itens nas coleções */
            if (!existeProdPend) {
              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              //console.log('criando novo wmsOsItensSepData')

              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }
            //console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
            //console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)
          }

          //ordenando em desc e destacando o item atual para o topo
          const idItemAtual = this.wmsOsItemData.iditem

          const itemAtual = this.wmsOsItensSepData.find(item =>
              item.iditem === idItemAtual
          );
          const outrosItens = this.wmsOsItensSepData.filter(item =>
              !(item.iditem === idItemAtual)
          );

          if (outrosItens && outrosItens.length > 0) {
            outrosItens.sort((a, b) => b.iditem - a.iditem);

            this.wmsOsItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
          } else if (itemAtual) {
            this.wmsOsItensSepData = [itemAtual]
          }

          if (this.totalItens === 0) {
            this.finalizadorConferencia()
          }
          //console.log(`Total de itens: ${this.wmsOsItensData}`)
          //console.log(`Total de itens2: ${this.wmsos}`)

          this.wmsOsItemData = {}
          this.$refs.produto.value = null
          this.$refs.qtdlida.value = null

          this.$refs.produto.focus()
        }
      }
    },

    roundToDecimal(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round(num * factor) / factor;
    },

    filtrarDisponiveis(arrayEntr) {
      //this.wmsOsItensData = res.data[6]
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        if (value.qtddisp > 0) {
          /*
          * Verificando se existe composição novamente
          */
          if(value.composicao) {
            this.flagConferenciaCompos = true
          }

          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    carregaWmsOsAvulso(){
      console.log('carregaWmsOsAvulso')

      api.get(`${getBaseUrl()}api/wmsosemabertos`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)

        this.wmsOsPedsData = res.data[0]
        this.wmsOsPedsES = res.data[1]

      }).then(() => {
        if(this.tamanhoTela < 500){
          setTimeout(() => {
            this.$refs.chave.focus()
          }, 500)
        } else {
          setTimeout(() => {
            this.$refs.produto.focus()
          }, 500)
        }
      })

    },

    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsossaida`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)

        if('success' in res.data && res.data.success !== true) {
          console.log('itens não foram completamente validados!')

          Swal.fire({
            position: "center",
            icon: "info",
            title: "Os itens para essa separação não foram reservados corretamente!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            //Valida se existe saldo ou precisa de gerar um ajuste
            this.remetCnpj = res.data.remetcnpj
            if(res.data.erroTipo === 'saldo'){
              console.log('reserva de saldos pendentes')

              this.dtListErrorsProdutos = res.data.itensSemSaldo
              this.showModalErrosProdutos = true
            } else if(res.data.erroTipo === 'reserva'){
              console.log('reserva de saldos pendentes')

              this.showModalAssociaLotes = true
              this.dtListAssociaLote = res.data.defLotes
            }
          })

          this.updating = false
          return
        }



        this.wmsOsData = res.data[0]
        this.wmsOsListData = res.data[4]
        this.wmsOsVolumesData = res.data[1]

        let totalVols = 0;
        let pesoVols = 0;
        this.wmsOsVolumesData.forEach((value) => {
          totalVols += value.qtd
          pesoVols += value.peso
        });
        this.somaQtdVolumes = totalVols
        this.somaPesoVolumes = pesoVols

        // this.transpData = res.data[2]
        this.clienteData = res.data[3]
        this.movData = res.data[5]

        this.wmsOsItensData = this.filtrarDisponiveis(res.data[6])
        //console.log(`carregarDados wmsOsItensData: ${JSON.stringify(this.wmsOsItensData)}`)
        this.wmsOsItensData.forEach((item) => {
          if(!item.desconsidsaldo){
            this.totalItens++
          }
        })
        console.log(`Total de itens: ${this.totalItens}`)

        this.itenswmsos = res.data[6]
        this.wmsOsItensSepData = res.data[7]

        this.tipoConferencia = this.flagProdutoSaldoWmsos ? 'M' : 'A'

        //Validando dados dadempresa
        if(!res.data[8]){
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Inconsistência nos dados da Empresa emissora do Wmsos",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }
        this.empresaData = res.data[8]

        this.tipoConferencia = this.empresaData.wmsosauto ?? 'A'
        this.mudarConferencia = this.empresaData.wmsconf ? this.empresaData.wmsconf : 'P'

        this.wmsOsDuplicadaData = res.data[9]
        if (this.wmsOsDuplicadaData && this.wmsOsDuplicadaData.id) {
          console.log('desativando funções...')
          this.desativaFuncoes = true

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de serviço em duplicidade, excluir esta ou a id: " + this.wmsOsDuplicadaData.id + " antes de continuar.",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }

        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        this.optionsCaixas = res.data[12]

        this.idData = this.wmsOsData.id
        this.title = `Editar OS de Saída (${this.wmsOsData.id}) ${this.clienteData != null ? this.clienteData.cidade + '/' + this.clienteData.estado : ''}`
        this.updating = false
      }).then(() => {
        setTimeout(() => {
          this.$refs.produto.focus()
        }, 500)
      })
    },

    confirmarVolume() {
      console.log('confirmarVolume')
      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0) {
        this.loadingWmsVolume = true
        // this.loadingWmsEnder = true
        // console.log(this.wmsOsItemSepData.produto)
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          'idwmsos': this.idData,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
          'caixa': this.wmsOsVolumeData.caixa
        }).then((res) => {
          console.log('then axios conf_vol')
          console.log(res.data)
          this.wmsOsVolumesData = res.data[0]
          let totalVols = 0
          let pesoVols = 0
          this.wmsOsVolumesData.forEach((value) => {
            totalVols += value.qtd
            pesoVols += value.peso
          });
          this.somaQtdVolumes = totalVols
          this.somaPesoVolumes = pesoVols
          this.loadingWmsVolume = false
          this.wmsOsVolumeData = {}
          this.$refs.caixapadrao.focus()
        })
      }
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    abrirShowConfManual() {
      console.log('abrirshowConfManual')

      this.showConfManual = true
    },

    onModalConfManual() {
      this.$refs.qtdlida.focus()
    },

    abrirShowListConf() {
      console.log('abrirShowListConf')

      if(this.idData === 0) {
        this.showListPed = true
      } else {
        this.showListConf = true
      }

    },

    abrirShowListFerramentas() {
      console.log('abrirShowListFerramentas')

      this.showListFerramentas = true
    },

    nomeStatusWms(stsIn) {
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'AB':
          result = 'Elaboração'
          break
        case 'ES':
          result = 'Em Separação'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};
</script>
<template>
    <div v-if="tamanhoTela > 500">
      <Layout>
        <PageHeader :title="title" :items="items" :status="wmsOsData.status"/>

        <Loader v-if="updating" style="min-height: 400px;">
        </Loader>

        <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
          <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
          favor ajustar e tentar novamente.
        </b-alert>

        <div class="col-lg-12" v-if="!updating">
          <div class="card">

              <div class="card-body">
                <div class="d-flex align-items-start">

                  <div class="flex-grow-1 align-self-center">
                    <div class="text-muted">
                      <h5>{{ wmsOsData !== null ? formatInteger(wmsOsData.qtddisp) : 0 }} pendente(s)</h5>
                      <p class="mb-1">{{ wmsOsData !== null ? formatInteger(wmsOsData.qtdlida) : 0 }} conferido(s) com sucesso
                      </p>

                      <p class="mb-1" v-if="wmsOsData && wmsOsData.dtconcl">
                        Usuário <strong>{{ wmsOsData !== null ? wmsOsData.updated_by : '' }}</strong>
                        <span> Conclusão: <strong> {{  formatDateTime(wmsOsData.dtconcl) }} </strong> </span>
                      </p>

                      <p><strong>Origem:</strong>
                        {{ wmsOsData.origem == 'orcamento' ? 'Orçamento' : wmsOsData.origem == 'nota' ? 'Mov' : wmsOsData.origem }}
                          - <strong>Id:</strong> <a href="javascript: void(0);" @click="redirecionaOrigem">{{ wmsOsData.origem_id }}</a>
                      </p>

                    </div>
                  </div>

                  <div class="flex-grow-1 align-self-center">
                    <div class="text-muted">
                      <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                      <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                      <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                    </div>
                  </div>

  <!--                <div v-if="tamanhoTela > 500">-->
                  <div>
  <!--                  <b-button variant="outline-primary" class="mx-2" @click="efetivarSepPend2" v-if="wmsOsItensSepPendData.length > 0 && !desativaFuncoes">
                      <i class="bx bx-check font-size-16 align-middle me-2"></i>
                      Salvar (alt + A)
                    </b-button>-->

                    <b-button :disabled="wmsOsData.status !== 'AB'" variant="outline-primary" class="mx-2" v-if="!desativaFuncoes"
                              @click="associarRomaneio">
                      Romaneio: {{ wmsOsData.wmsroma_id }}
                    </b-button>

                    <b-button :disabled="!wmsOsVolumesData || wmsOsVolumesData.length === 0" variant="outline-primary" v-if="!desativaFuncoes"
                              class="mx-2" @click="imprimirEtiquetasZpl">
                      <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                      Etiquetas (alt + F)
                    </b-button>

                    <b-button variant="outline-primary" class="mx-2" @click="abrirModalVolume" v-if="!desativaFuncoes">
                      <i class="bx bx-box font-size-16 align-middle me-2"></i>
                      Volumes (alt + V)
                    </b-button>


                    <b-button variant="outline-warning" class="mx-2" @click="reiniciar" v-if="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB') && !desativaFuncoes">
                      <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                      Reiniciar (alt + R)
                    </b-button>

                    <b-button variant="outline-success" class="mx-2" @click="separarTodos" v-if="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB') && !desativaFuncoes && !flagProdutoSaldoWmsos">
                      <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                      Conferir Todos
                    </b-button>

                    <b-button variant="outline-info" class="mx-2" @click="finalizarParcial" v-if="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB' && empresaData.geraped === 'OS') &&  !desativaFuncoes">
                      <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                      Finalizar OS Parcialmente
                    </b-button>

                    <b-button variant="outline-danger" class="mx-2"
                              v-if="wmsOsData.status === 'ES' || wmsOsData.status === 'AB' || wmsOsData.status === 'EL'"
                              @click="excluir">
                      <i class="mdi mdi-trash-can me-1 text-end"></i>
                      Excluir
                    </b-button>

                    <button class="btn btn-success mx-2"
                            v-if="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB' || wmsOsData.status === 'CP') && !desativaFuncoes && !flagProdutoSaldoWmsos"
                            @click="finalizar">
                      <i class="mdi mdi-check me-1 text-end"></i>
                      Finalizar (alt + Z)
                    </button>

                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="row" v-if="!updating">

          <div class="col-xl-8">
            <b-card-text>
              <div class="card">
                <div class="card-body">

                  <form class="needs-validation">
                    <div class="row">
                      <div class="col-sm-6" v-if="wmsOsData.origem == 'mov'">
                        <div class="mb-3">
                          <label for="chave">Chave</label>
                          <input id="chave" v-model="movData.chave" type="text" class="form-control" placeholder="Chave" ref="chave"
                                 :disabled="computedDisabledChave" :class="{ 'is-invalid': submitted && !movData.chave }" @keydown.enter="carregaWmsOs" />
                          <div v-if="submitted && !movData.chave" class="invalid-feedback">
                            <span>Campo nome obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>


                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="cliente">Cliente</label>
                          <input id="cliente" v-model="clienteData.nome" type="text" :disabled="true" class="form-control"
                                 placeholder="Cliente" />
                        </div>
                      </div>


                      <div class="col-sm-2" v-if="wmsOsData.origem == 'orcamento'">
                        <div class="mb-3">
                          <label for="numnf">Orçamento</label>
                          <input id="numnf" v-model="wmsOsData.origem_id" type="text" :disabled="true" class="form-control"
                                 placeholder="Nota F." />
                        </div>
                      </div>

                      <div class="col-sm-2" v-if="wmsOsData.origem == 'mov'">
                        <div class="mb-3">
                          <label for="numnf">Nota Fiscal</label>
                          <input id="numnf" v-model="movData.codigo" type="text" :disabled="true" class="form-control"
                                 placeholder="Nota F." />
                        </div>
                      </div>


                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label for="produto">Código do Item</label>
                          <!--Regra de disable retirada(Pablo)-->
                          <!--:disabled="this.updatingListas || wmsOsData.status !== 'EL' || desativaFuncoes"-->
                          <input id="produto" v-model="wmsOsItemData.produto" type="text" ref="produto" class="form-control"
                                 placeholder="Produto (alt + S)" @keypress.enter="informouProduto"
                                 :class="{ 'is-invalid': submitted && !wmsOsItemData.produto }" />
                          <div v-if="submitted && !wmsOsItemData.produto" class="invalid-feedback">
                            <span>Campo nome obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label for="qtd">Quantidade de Itens</label>
                          <input id="qtd" v-model="wmsOsItemData.qtd" type="number" :disabled="true" class="form-control"
                                 placeholder="Quantidade de Itens" />
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label for="qtdlida">Quantidade a ser lida</label>
                          <input id="qtdlida" ref="qtdlida" v-model="wmsOsItemData.qtdlida" type="number"
                                 class="form-control" :disabled="tipoConferencia === 'A'" @keypress.enter="informouQtdLida2"
                                 placeholder="Quantidade a ser lida" />
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="mb-3 align-items-end align-content-end float-end" v-if="flagAvulso">
                          <h5 class="font-size-14">Auto-impressão</h5>
                          <b-form-checkbox switch size="lg" v-model="autoImpressao" @click="changeAutoImpressao">
                            {{ autoImpressao === true ? 'On' : 'Off' }}
                          </b-form-checkbox>
                        </div>

                        <div class="mb-3 align-items-end align-content-end float-end" v-if="this.mudarConferencia === 'P'">
                          <h5 class="font-size-14">Conferência</h5>
                          <b-form-checkbox switch size="lg" value="A" unchecked-value="I" v-model="tipoConferencia">
                            {{ tipoConferencia === 'A' ? 'Auto' : 'Manual' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-6" v-if="flagProdutoSaldoWmsos">
                        <div class="mb-3">
                          <label for="lote">Lotes</label>
                          <select
                              id="lotes"
                              ref="selectLotes"
                              class="form-select form-select-sm"
                              style="padding: 5px 10px"
                              v-model="wmsOsItemData.lote"
                              @change="selecionouLote"
                          >
                            <option disabled value="">Selecione uma Lote</option>
                            <option v-for="lotes in dtListLotes"
                                    :key="lotes.lote"
                                    :value="lotes.lote"
                            >
                              {{ lotes.lote }}
                            </option>
                          </select>
                        </div>
                      </div>



                      <div class="row">



                      </div>




                    </div>

                  </form>


                  <Loader v-if="updatingListas" style="min-height: 200px;">
                  </Loader>

                  <div class="row mt-5 mb-2" v-if="!updatingListas">

                    <h4 class="card-title">Itens do pedido para separação ({{ wmsOsItensData !== null ?
                        wmsOsItensData.length : 0 }}) - Status:
                      <span class="badge badge-pill badge-soft-info font-size-16">{{ nomeStatus(wmsOsData.status) }}</span>
                    </h4>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>Produto</th>
                          <th>Descrição</th>
                          <th class="text-end">Localização</th>
                          <th class="text-end">Lote</th>
                          <th class="text-end">Lidos</th>
                          <th class="text-end">Total</th>
                          <th>UND</th>
                          <th class="text-end">Estoque</th>
                          <th class="text-start" v-if="flagConferenciaCompos">Composição de Produto</th>
                          <th class="text-end" v-if="flagConferenciaCompos">Valor</th>
                          <th class="text-end" v-if="flagConferenciaCompos">Fator</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in wmsOsItensData" :key="data.id">

                          <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                             @click="clicouProduto(data.produto, data.id, data.produto_id, data.composicao?.qtd ?? null, data.composicao?.fator ?? null, data.lote, data.endwms)">

                            <td>
                              <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img"
                                   class="avatar-md" />

                              <div class="mb-3" v-else>
                                <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                              </div>

                              <h6 class="text-muted mb-0">Sku: {{ data.codigo }} </h6>
                              <!--                          <p></p>-->
                              <h4 class="text-muted mb-0">{{ data.produto }} </h4>
                            </td>

                          </a>


                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                                 @click="editarProduto(data.id)">
                                {{ data.descprod }}
                              </a>
                            </h5>
                            <p class="mb-0">
                              <!--                      Saldo:-->
                              <!--                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>-->
                            </p>
                          </td>

                          <td class="text-end">{{ data.endwms ?? '-'}}</td>
                          <td class="text-end">{{ data.lote ?? '-' }}</td>
                          <td class="text-end">{{ formatDecimal(data.qtdlida) }}</td>
                          <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
                          <td class="text-end">{{ data.und !== null ? data.und : '-'}}</td>
                          <td class="text-end">{{ '-' }}</td>

                          <td class="text-end" v-if="flagConferenciaCompos">
                            {{ Array.isArray(data.composicao) && data.composicao.length ? data.composicao[0].prodcomp_id : '-' }}
                          </td>
                          <td class="text-end" v-if="flagConferenciaCompos">
                            {{ Array.isArray(data.composicao) && data.composicao.length ? formatDecimal(data.composicao[0].qtd) : '-' }}
                          </td>
                          <td class="text-end" v-if="flagConferenciaCompos">
                            {{
                              Array.isArray(data.composicao) && data.composicao.length
                                  ? (data.composicao[0].fator === '/' ? 'Divisão' : 'Multiplicação')
                                  : '-'
                            }}
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>
              </div>

            </b-card-text>
          </div>

          <div class="col-xl-4">
            <b-card-text>
              <div class="card">
                <div class="card-body">
                  <div class="row mb-2">

                    <Loader v-if="updatingListas" style="min-height: 200px;">
                    </Loader>

                    <h4 class="card-title">
                      Produtos lidos ({{ wmsOsItensSepData !== null ? wmsOsItensSepData.length : 0 }})
                    </h4>

                    <div class="table-responsive" v-if="!updatingListas">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>Produto</th>
                          <th>Descrição</th>
                          <th v-if="flagProdutoSaldoWmsos">Lote</th>
                          <th class="text-success">Conferidos</th>
                          <th class="text-danger">Pendentes</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in wmsOsItensSepData" :key="data.id">
                          <td>
                            <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img"
                                 class="avatar-md" />

                            <div class="mb-3" v-else>
                              <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                            </div>
                          </td>

                          <td>
                            <h5 class="font-size-12 text-truncate">
                              <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                                 @click="editarProduto(data.id)">
                                {{ data.descprod }}
                              </a>
                            </h5>

                            <h6 class="text-muted mb-0">Sku: {{ data.codigo }} </h6>
                            <h6 class="text-black-50 mb-0">{{ data.produto }} </h6>
                          </td>

                          <td v-if="flagProdutoSaldoWmsos">
                            <h5 class="font-size-12 text-truncate text-start">
                              {{ data.lote }}
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-12 text-truncate text-start">
                              {{ formatDecimal(data.qtd) }}
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-12 text-truncate text-start">
                              {{ wmsOsData.status === 'AB' ? formatDecimal(data.qtdtotal) : 0 }}
                            </h5>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </div>
        </div>
      </Layout>
    </div>

    <div class="col-lg-12 full-height-wrapper" v-if="!updating && tamanhoTela < 500">

      <div class="card full-height-card">
        <div class="card-body full-height-body">

          <div class="row">
            <div class="col-6">
              <label :class="wmsOsData.status === 'SE' ? 'badge badge-soft-success' : 'badge badge-soft-warning'"
                     style="position: fixed; top: 10px; left: 5px; z-index: 1000;"
              >
                {{ nomeStatusWms(wmsOsData.status) }}
              </label>
            </div>


            <button title="Retornar para WmsOS List" @click="retornaParaWmsos" class="btn col-1 p-1 m-1 border-0 font-size-16"
                style="position: fixed; top: 0px; right: 5px; background-color: white; z-index: 1000;"
            >
              <i class="bx bx-undo"></i>
            </button>

<!--            <div class="col-6">
              <b-form-checkbox switch size="sm" value="A" unchecked-value="I" v-model="tipoConferencia">
                {{ tipoConferencia === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
              </b-form-checkbox>
            </div>-->

            <div class="d-flex justify-content-between"  style="margin-top: 5px">

              <button class="btn p-1 m-1 border-0 font-size-16" @click="recarregaWmsosAvulso">
                <i class="bx bx-sync"></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                      @click="efetivarSepPend2" :disabled="this.idData === 0">
                <i class="bx bx-save"></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                      @click="abrirShowListConf">
                <i class="bx bx-list-ul"></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                      :disabled="this.idData === 0" @click="abrirShowListFerramentas">
                <i class="bx bx-layer "></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-14" @click="initFullScreen">
                <i class="bx bx-fullscreen"></i>
              </button>

            </div>
          </div>


          <form class="needs-validation">
            <div id="step1" v-if="activeStep === 0 && idData > 0 && wmsOsData.origem === 'mov'" class="row">
              <div class="col-sm-12">
                <div class="mb-3">
                  <label for="chave">Chave / Ordem de Serviço(ID)</label>
                  <input id="chave" v-model="movData.chave" type="text" class="form-control" placeholder="Chave / Ordem de Serviço ID" ref="chave"
                         :disabled="computedDisabledChave" :class="{ 'is-invalid': submitted && !movData.chave }" @keydown.enter.prevent="carregaWmsOs" />
                  <div v-if="submitted && !movData.chave" class="invalid-feedback">
                    <span>Campo nome obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="nav-buttons">
                <button type="button" disabled class="btn-nav btn-back">
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="goToStep(1)">
                  Próximo
                </button>
              </div>
            </div>

            <div id="step1" v-if="idData === 0 && activeStep === 1" class="row mb-4">
              <div v-if="idData === 0" class="col-sm-12 mb-5">
                <div class="mb-3">
                  <label for="chave">Chave / Ordem de Serviço(ID)</label>
                  <input
                      id="chave"
                      v-model="movData.chave"
                      type="text"
                      class="form-control compact-input"
                      placeholder="Chave/OS ID"
                      ref="chave"
                      :disabled="computedDisabledChave"
                      :class="{ 'is-invalid': submitted && !movData.chave }"
                      @keydown.enter.prevent="carregaWmsOs"
                  />

                  <div v-if="submitted && !movData.chave" class="invalid-feedback">
                    <span>Campo nome obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div v-if="wmsOsPedsES?.length > 0" class="col-md-12">

                  <div class="table-responsive" style="max-height: 120px; overflow-y: auto;">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Wms<br>OS</th>
                        <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Nota<br>Fiscal</th>
                        <th class="text-end" style="white-space: normal; max-width: 5px; padding-top: 3px; padding-bottom: 3px;">Mov/<br>Orcto</th>
                      </tr>
                      </thead>
                      <tbody>

                      <template v-for="(data, index) in wmsOsPedsES" :key="data.id">
                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="clicouPedido(data.id)"
                            >
                              {{ data.id }}
                            </a>
                          </td>

                          <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.numnf }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.origem_id }}</td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="nav-buttons">
                <button type="button" disabled class="btn-nav btn-back">
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="carregaWmsOs">
                  Próximo
                </button>
              </div>
            </div>

             <div id="step2" v-if="idData > 0 && activeStep === 1" class="row">
                <div class="col-sm-12">
                  <label for="cliente">
                    {{ clienteData.nome }}
                    <label for="numnf" v-if="wmsOsData.origem === 'orcamento'"> (Orc. ID: {{ wmsOsData.origem_id }})</label>
                    <label for="numnf" v-else-if="wmsOsData.origem === 'mov'"> (NF: {{ movData.codigo }})</label>
                  </label>

                  <div class="mb-2">
                    <label for="produto">Código do Item</label>
                    <input id="produto"
                           v-model="wmsOsItemData.produto"
                           type="text"
                           ref="produto"
                           class="form-control compact-input"
                           placeholder="Produto (alt + S)"
                           @keypress.enter.prevent="informouProduto"
                           :class="{ 'is-invalid': submitted && !wmsOsItemData.produto }"
                    />
                    <div v-if="submitted && !wmsOsItemData.produto" class="invalid-feedback">
                      <span>Campo nome obrigatório, favor preencher.</span>
                    </div>
                  </div>

                </div>

               <div class="row mb-2" v-if="movData.codigo > 0 && selectedItem">

                 <div class="table-responsive">
                   <table class="table align-middle mb-0 table-nowrap">
                     <thead>
                     <tr>
                       <td style="padding: 0px 2px">Sku</td>
                       <td class="text-danger" style="padding: 0px 2px">Pend.</td>
                       <td class="text-success" style="padding: 0px 2px">Conf.</td>
                     </tr>
                     </thead>
                     <tbody>
                     <tr :key="selectedItem.id">
                       <td>
                         <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                            @click="clicouProduto(selectedItem.produto, selectedItem.id, selectedItem.produto_id,
                            selectedItem.composicao?.qtd ?? null, selectedItem.composicao?.fator ?? null,
                            selectedItem.lote, selectedItem.endwms)">
                             <h6 class="text-muted mb-0">{{ selectedItem.produto }} </h6>

                         </a>
                       </td>
                       <td class="text-danger">{{ selectedItem.qtddisp }}</td>
                       <td class="text-success">{{ selectedItem.qtdlida }}</td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>

               <div class="nav-buttons">
                 <button type="button" :disabled="wmsOsData.origem !== 'mov'" class="btn-nav btn-back" @click="goToStep(0)" >
                   Voltar
                 </button>
                 <button type="button" class="btn-nav btn-next" @click="informouProduto">
                   Próximo
                 </button>
               </div>
             </div>
          </form>

        </div>
      </div>
    </div>

    <b-modal size="lg" @shown="$refs.caixapadrao.focus()" @hidden="onModalClosed" title="Volume(s)" v-model="showModalVolume" centered
      hide-footer>

      <div class="col-12">
        <div class="d-flex mb-3">
          <label for="caixapadrao" class="me-1 mb-0 small">Caixa Padrão</label>
          <select
              id="caixapadrao"
              ref="caixapadrao"
              class="form-select form-select-sm"
              style="padding: 5px 10px"
              v-model="wmsOsVolumeData.caixa"
              @change="escolheuCaixa"
          >
            <option disabled value="">Selecione uma caixa</option>
            <option v-for="caixa in optionsCaixas"
                :key="caixa.id"
                :value="caixa.id"
            >
              {{ caixa.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div class="row align-items-center" style="margin-top: -10px">

        <div class="col-6 mb-2 align-items-center">
          <label for="qtdvolume" class="me-2 mb-0 small" style="white-space: nowrap;">Qtd.:</label>
          <input id="qtdvolume"
            ref="qtdvolume"
            v-model="wmsOsVolumeData.qtd"
            type="number"
            class="form-control form-control-sm text-end"
            @keypress.enter="informouQtdVolume"
            placeholder="Enter Qtd..."
            style="width: 100%; max-width: 100px;"
          />
        </div>

        <div class="col-6 mb-2 align-items-center">
            <label for="pesovolume" class="me-2 mb-0 small" style="white-space: nowrap;">Peso:</label>
            <input id="pesovolume"
              ref="pesovolume"
              v-model="wmsOsVolumeData.peso"
              type="number"
              class="form-control form-control-sm text-end"
              @keypress.enter="informouPeso"
              placeholder="Enter Vol..."
              style="width: 100%; max-width: 100px;"
            />
        </div>
        <div class="col-12 text-end">
          <b-button type="submit" variant="warning"
                    :disabled="!this.wmsOsVolumeData.caixa || !this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0 || !this.wmsOsVolumeData.peso || this.wmsOsVolumeData.peso <= 0"
                    @click="confirmarVolume">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Enter Novo Volume
          </b-button>
        </div>
      </div>

      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
            <tr>
              <th scope="col" class="col-5 p-1 small">Etiqueta <i class="mdi mdi-printer"></i></th>
              <th scope="col" class="col-1 text-center p-1 small">ID Caixa  </th>
              <th scope="col" class="col-1 text-end p-1 small">Peso</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in wmsOsVolumesData" :key="data.id">
              <td class="col-6 p-1 text-info small">
                <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)" style="font-size: 10px; white-space: normal; word-break: break-all; max-width: 120px;">
                  <i class="mdi mdi-printer"></i>
                  <span>
                    {{ data.etiqueta }}
                  </span>

                </a>
              </td>

              <td class="text-center p-1 small" style="font-size: 10px">
                {{ (data.caixa_id) }}
              </td>

              <td class="text-end p-1 small" style="font-size: 10px">
                {{ formatDecimal(data.peso) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="font-size: 11px; margin-top: -10px;">
        <label><strong>Total Qtd.:</strong> <span>{{ formatDecimal(somaQtdVolumes) }}</span></label>
        <label class="ms-2"><strong>Total Peso:</strong> <span>{{ formatDecimal(somaPesoVolumes) }}</span></label>
      </div>

      <div class="d-flex justify-content-between">
        <b-button title="Excluir Etiquetas"
            type="submit"
            variant="outline-danger"
            size="sm"
            class="px-2 mx-2"
            v-if="wmsOsVolumesData.length > 0"
            @click="excluirEtiquetas"
        >
          <i class="bx bxs-trash font-size-14 align-middle mx-2"></i>
<!--          Excluir Etiquetas-->
        </b-button>

        <b-button title="Confirmar Volumes"
            type="submit"
            variant="success"
            size="sm"
            class="px-2"
            @click="showModalVolume = false"
        >
          <i class="bx bx-check-double font-size-14 align-middle mx-2"></i>
<!--          Confirmar Volumes-->
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Associar a Romaneio" v-model="showAssocRoma" centered hide-footer>
      <div class="col-md-12">

        <div class="col-12">
          <div class="mb-3">
            <label for="lote">Selecionar Romaneio</label>
            <multiselect id="inputRomaneio" @search-change="pesqRomaneio" v-model="wmsOsData.wmsroma_id"
              placeholder="Pesquisar romaneio" :options="dtListPesqRoma" :searchable="true" label="nome" track-by="nome"
              value-prop="id"
            >
              <template #option="slotProps">
                <div class="row">
                  <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                    <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="row justify-content-around mt-3">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button :disabled="wmsOsData.wmsroma_id === 0" type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="confirmarAssocRoma()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>


    </b-modal>

    <b-modal title="Confer. Manual" v-model="showConfManual" @shown="onModalConfManual" centered hide-footer>
      <div class="col-md-12">

        <!--                  Modal para colocar itens quando conf. for manual-->

        <div class="col-sm-6" v-if="selectedItem?.id">
          <div class="mb-3">
            <label for="codprod">Código do Item</label>
            <input id="codprod" v-model="selectedItem.produto" type="text" class="form-control"
                   disabled />
          </div>
        </div>

          <div class="row">
            <div class="col-6">
              <label for="qtd">Qtd. Itens</label>
              <input id="qtd" v-model="wmsOsItemData.qtd" type="number" :disabled="true" class="form-control"
                     placeholder="Quantidade de Itens" />
            </div>

            <div class="col-6">
              <label for="qtdlida">Qtd. Disp.</label>
              <input id="qtdlida" ref="qtdlida" v-model="wmsOsItemData.qtdlida" type="number"
                     class="form-control" :disabled="tipoConferencia === 'A'" @keypress.enter="informouQtdLida2"
                     placeholder="Quantidade a ser lida" />
            </div>
          </div>

        <div class="row justify-content-around mt-3">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showConfManual = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="informouQtdLida2()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Confer. Lote" v-model="showModalLote" centered hide-footer>
      <div class="col-md-12">

        <div class="col-12">
          <div class="mb-3">
            <label for="lote">Lotes</label>
            <select
                id="lotes"
                ref="selectLotes"
                class="form-select form-select-sm"
                style="padding: 5px 10px"
                v-model="wmsOsItemData.lote"
                @change="selecionouLote"
            >
              <option disabled :value="null">Selecione uma Lote</option>
              <option v-for="lotes in dtListLotes"
                      :key="lotes.lote"
                      :value="lotes.lote"
              >
                {{ lotes.lote }}
              </option>
            </select>
          </div>
        </div>

        <div class="row justify-content-around mt-3">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showModalLote = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="informouQtdLida2()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Lista de Conferência" v-model="showListConf" centered hide-footer>
        <div class="col-md-12">

          <div class="table-responsive">
            <table class="table align-middle mb-0 table-nowrap">
              <thead class="table-light">
              <tr>
                <th>SKU</th>
                <th class="text-end">Lidos</th>
                <th class="text-end">Total</th>
              </tr>
              </thead>
              <tbody>

              <template v-for="(data, index) in wmsOsItensData" :key="data.id">
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td style="padding-top: 3px; padding-bottom: 3px;">
                    <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                       @click="clicouProduto(data.produto, data.id, data.produto_id, data.composicao?.qtd ?? null, data.composicao?.fator ?? null, data.lote, data.endwms)">
                      {{ data.produto }}
                    </a>
                  </td>

                  <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                  <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
                </tr>
                <tr v-if="data.deflote" :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  Lote: {{ data.lote ?? 'Não Definido' }}
                  </td>
                </tr>
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                    {{ data.descprod.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                  </td>
                </tr>

              </template>
              </tbody>
            </table>
          </div>
        </div>

      </b-modal>

    <b-modal title="Ferramentas" v-model="showListFerramentas" centered hide-footer>
      <div class="col-md-12">

        <!--                  Modal para colocar itens quando conf. for manual-->
        <div class="col-12 d-flex justify-content-center">
          <b-form-checkbox switch size="sm" value="A" unchecked-value="I" v-model="tipoConferencia">
            {{ tipoConferencia === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
          </b-form-checkbox>
        </div>

        <div class="col-12 d-flex justify-content-center" v-if="flagAvulso">
          <b-form-checkbox switch size="sm" v-model="tipoConferencia" @click="changeAutoImpressao">
            {{ autoImpressao === true ? 'Auto-impressão On' : 'Auto-impressão Off' }}
          </b-form-checkbox>
        </div>

        <div class="col-12" v-if="wmsOsData.status === 'AB'">
          <a  class="dropdown-item text-primary text-center"
              @click="associarRomaneio"
              href="javascript: void(0);"
              title="Assoc. Romaneio">
            Romaneio: {{ wmsOsData.wmsroma_id }}
          </a>
        </div>

        <div class="col-12" v-if="wmsOsVolumesData || wmsOsVolumesData.length > 0">
          <a  class="dropdown-item text-primary text-center"
              @click="imprimirEtiquetasZpl"
              href="javascript: void(0);">
            Etiquetas Mini Danfe
          </a>
        </div>

        <div class="col-12" v-if="wmsOsVolumesData || wmsOsVolumesData.length > 0">
          <a  class="dropdown-item text-primary text-center"
              @click="abrirModalVolume"
              href="javascript: void(0);">
            Volumes
          </a>
        </div>

        <div class="col-12" v-if="wmsOsData.status === 'ES' || wmsOsData.status === 'AB'">
          <a class="dropdown-item text-primary text-center"
             @click="separarTodos"
             href="javascript: void(0);">
             Separar Todos
          </a>
        </div>

        <div class="col-12" v-if="wmsOsData.status === 'ES' || wmsOsData.status === 'AB' && empresaData.geraped === 'OS'">
          <a class="dropdown-item text-primary text-center"
             @click="finalizarParcial"
             href="javascript: void(0);">
             Finalizar OS Parcialmente
          </a>
        </div>

        <div class="col-12" v-if="wmsOsData.status === 'ES'">
          <a class="dropdown-item text-primary text-center"
             @click="excluir"
             href="javascript: void(0);">
             Excluir
          </a>
        </div>

        <div class="col-12" v-if="wmsOsData.status === 'ES' || wmsOsData.status === 'SE'">
          <a class="dropdown-item text-primary text-center"
             @click="finalizar"
             href="javascript: void(0);">
             Finalizar
          </a>
        </div>

      </div>

    </b-modal>

    <b-modal title="Lista de Conferência" v-model="showListPed" centered hide-footer>
      <div class="col-md-12">

        <div class="table-responsive">
          <table class="table align-middle mb-0 table-nowrap">
            <thead class="table-light">
            <tr>
              <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Wms<br>OS</th>
              <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Nota<br>Fiscal</th>
              <th class="text-end" style="white-space: normal; max-width: 5px; padding-top: 3px; padding-bottom: 3px;">Mov/<br>Orcto</th>
            </tr>
            </thead>
            <tbody>

            <template v-for="(data, index) in wmsOsPedsData" :key="data.id">
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">
                  <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                     @click="clicouPedido(data.id)"
                  >
                    {{ data.id }}
                  </a>
                </td>

                <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.numnf }}</td>
                <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.origem_id }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>

  </b-modal>

</template>

<style scoped>
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
}

.full-height-card {
  height: 100%;
  margin-bottom: 0;
  border-radius: 0;
}

.full-height-body {
  height: 100%;
  overflow: hidden;
}

.compact-card {
  margin: 0;
  border-radius: 4px;
  box-shadow: none;
  border: 1px solid #e0e0e0;
}

.compact-body {
  padding: 4px 6px;
  margin: 0;
}

.compact-header {
  margin-bottom: 4px;
  font-size: 11px;
}

.compact-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 2px;
}

.btn-compact {
  background: none;
  border: 1px solid #ddd;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 12px;
  min-width: 28px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-compact:hover {
  background-color: #f5f5f5;
}

.compact-form {
  margin: 0;
}

.step-container {
  min-height: 100vh;
}

.field-group {
  margin-bottom: 8px;
}

.compact-label {
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 2px;
  display: block;
  color: #333;
}

.compact-input {
  font-size: 12px;
  padding: 4px 6px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 100%;
}

.compact-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0,123,255,.25);
  outline: none;
}

.compact-input.is-invalid {
  border-color: #dc3545;
}

.error-msg {
  font-size: 9px;
  color: #dc3545;
  margin-top: 2px;
}

.client-info {
  background: #f8f9fa;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 6px;
  font-size: 10px;
}

.client-name {
  font-weight: 600;
  display: block;
  color: #333;
  line-height: 1.2;
}

.client-detail {
  color: #666;
  font-size: 9px;
}

.item-info {
  background: #e8f4f8;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 8px;
  font-size: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
}

.item-label {
  font-weight: 600;
  color: #555;
}

.item-value {
  color: #333;
  font-weight: 500;
}

.nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1000;
  gap: 6px;
}

.btn-nav {
  flex: 1;
  padding: 6px 4px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid;
  background: white;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-back:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.btn-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-next {
  border-color: #28a745;
  color: #28a745;
}

.btn-next:hover {
  background-color: #28a745;
  color: white;
}
</style>
